export default "__VITE_ASSET__Bii2JDCs__"